import React, { PureComponent } from 'react';
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

export default (key = 'optionsLocations') => WrappedComponent => class WithLocations extends PureComponent {
    render() {
        //console.log(getSearch())
       // const locations = getLocations(this.props)
        return (
            <Query
                query={gql`{
                    optionsLocations {
                        locations {
                          country
                          title
                          address
                          zip
                          phone
                          mail
                          region
                          url
                          img {
                            sourceUrl
                          }
                        }
                        labelAfrica
                        labelAsia
                        labelAustralia
                        labelEurope
                        labelNorthAmerica
                        labelSouthAmerica
                      }
                }


        `}
            >
                {({ loading, error, data }) => (
                    <div>
                        {!error &&
                            <WrappedComponent
                                {...this.props}
                                {...{
                                    [`${key}Loading`]: loading,
                                    [key]: !loading ? data : undefined
                                }}
                            />
                        }
                        {error && <h1>Error: {error.message}</h1>}
                    </div>
                )}
            </Query>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/withLocations.js